import React from 'react';
import renderDescription from 'components/inbox/mail-table/functions/RenderDescription';
import './MatchedRulePopover.styl';
import BulletedRuleDescription from 'components/triggers/BulletedRuleDescription';
import RuleNotificationToggle from 'components/triggers/rules/RuleNotificationToggle';
import GenericTooltip from 'components/pure/tooltips/GenericTooltip';
import classNames from 'classnames';
import GenericLink from 'components/GenericLink';
import {TOOLTIP_DELAY} from 'components/StatsPage2.utils';

export default class MatchedRulePopover extends React.Component {
  render() {
    const {inboxItem, triggerRules} = this.props;
    const hasTriggers = triggerRules.size > 0;
    const horizontal = hasTriggers ? 'middle' : 'left';

    return (
      <div className="matched-rule-popover">
        <GenericTooltip
          hoverBehavior
          clickToClose={false}
          className="matched-rule-tooltip"
          anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
          targetOrigin={{
            horizontal: horizontal,
            vertical: 'top',
          }}
          delay={TOOLTIP_DELAY}
          tooltip={
            <div className="why-was-i-notified">
              <div>
                {hasTriggers && inboxItem && (
                  <div className="header">
                    <p className="vertical-header">The matching condition(s):</p>
                  </div>
                )}
                {inboxItem && (
                  <div className={classNames(hasTriggers && 'notif-conditions')}>
                    {renderDescription(inboxItem)}
                  </div>
                )}
              </div>
              {hasTriggers && (
                <div className="header">
                  <p className="vertical-header">The matching rule(s):</p>
                </div>
              )}
              <div className="notif-rules">
                {triggerRules.map(triggerRule => (
                  <TriggerRuleDetail
                    key={triggerRule.id}
                    triggerRule={triggerRule}
                    {...this.props}
                  />
                ))}
              </div>
            </div>
          }>
          <GenericLink>Why Was I Notified?</GenericLink>
        </GenericTooltip>
      </div>
    );
  }
}

const TriggerRuleDetail = ({triggerRule, toggleNotify}) => {
  const hasNotifyOn = !!triggerRule.rulePermissions.NOTIFY;

  return (
    <div className="notification-details">
      <div>
        <div className="notif-more-info">
          <BulletedRuleDescription text={triggerRule.name} timing={triggerRule.trendDescription} />
        </div>
      </div>
      <div className="notif-toggle-row">
        <RuleNotificationToggle rule={triggerRule} toggleNotify={toggleNotify} />
        <span className="detail">
          {hasNotifyOn ? 'You are subscribed to this rule' : 'You are unsubscribed from this rule'}
        </span>
      </div>
      <GenericLink onClick={() => toggleNotify(triggerRule, hasNotifyOn)}>
        {hasNotifyOn ? 'Unsubscribe' : 'Subscribe'}
      </GenericLink>
    </div>
  );
};
